import { defineStore } from "pinia"
import { ref } from "vue"

export const usePreviousStateModalStore = defineStore(
  "previousStateModal",
  () => {
    const isActive = ref(false)

    return {
      isActive,
    }
  }
)
